__turbopack_context__.v({
  "about": "product-view-module-scss-module__arml0q__about",
  "accordions": "product-view-module-scss-module__arml0q__accordions",
  "cards": "product-view-module-scss-module__arml0q__cards",
  "detail": "product-view-module-scss-module__arml0q__detail",
  "dir": "product-view-module-scss-module__arml0q__dir",
  "dir-cta": "product-view-module-scss-module__arml0q__dir-cta",
  "dir-eyebrow": "product-view-module-scss-module__arml0q__dir-eyebrow",
  "dir-text": "product-view-module-scss-module__arml0q__dir-text",
  "dir-title": "product-view-module-scss-module__arml0q__dir-title",
  "dirs": "product-view-module-scss-module__arml0q__dirs",
  "dot": "product-view-module-scss-module__arml0q__dot",
  "eyebrow": "product-view-module-scss-module__arml0q__eyebrow",
  "h2": "product-view-module-scss-module__arml0q__h2",
  "h2large": "product-view-module-scss-module__arml0q__h2large",
  "hotcard": "product-view-module-scss-module__arml0q__hotcard",
  "hotcta": "product-view-module-scss-module__arml0q__hotcta",
  "hoteyebrow": "product-view-module-scss-module__arml0q__hoteyebrow",
  "hothead": "product-view-module-scss-module__arml0q__hothead",
  "hotname": "product-view-module-scss-module__arml0q__hotname",
  "hotprice": "product-view-module-scss-module__arml0q__hotprice",
  "hotspot": "product-view-module-scss-module__arml0q__hotspot",
  "hotthumb": "product-view-module-scss-module__arml0q__hotthumb",
  "info": "product-view-module-scss-module__arml0q__info",
  "intro": "product-view-module-scss-module__arml0q__intro",
  "last-panel": "product-view-module-scss-module__arml0q__last-panel",
  "last-trigger": "product-view-module-scss-module__arml0q__last-trigger",
  "lead": "product-view-module-scss-module__arml0q__lead",
  "panel": "product-view-module-scss-module__arml0q__panel",
  "practice": "product-view-module-scss-module__arml0q__practice",
  "root": "product-view-module-scss-module__arml0q__root",
  "scene": "product-view-module-scss-module__arml0q__scene",
  "scene-photo": "product-view-module-scss-module__arml0q__scene-photo",
  "section": "product-view-module-scss-module__arml0q__section",
  "spec": "product-view-module-scss-module__arml0q__spec",
  "specs": "product-view-module-scss-module__arml0q__specs",
  "top": "product-view-module-scss-module__arml0q__top",
  "x": "product-view-module-scss-module__arml0q__x",
});
